// NB!: Don't include it in atoms/index.js to not include tinymce dependency on each page
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import RichTextEditor from '@atoms/RichTextEditor';
import Form from '@organisms/Form';

const RichTextField = (props) => (
  <Form.Item {...props}>
    <RichTextEditor include={props.include} exclude={props.exclude} showImageSelection={props.showImageSelection} initKey={props.initKey} />
  </Form.Item>
);

export default RichTextField;
